/* =====================================================================
   VITTORIO SARTI — theme.js  v2.0.0
   ===================================================================== */
(function () {
  'use strict';

  var mq = window.matchMedia('(min-width:1025px)');
  var isDesktop = function () { return mq.matches; };

  /* ---------------- reveal on scroll ---------------- */
  (function () {
    var nodes = document.querySelectorAll('.reveal');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
    nodes.forEach(function (n) { io.observe(n); });
  })();

  /* hero reveals immediately, staggered */
  window.addEventListener('load', function () {
    document.querySelectorAll('.hero .reveal').forEach(function (el, i) {
      setTimeout(function () { el.classList.add('in'); }, 180 + i * 170);
    });
  });

  /* ---------------- sticky header shadow ---------------- */
  (function () {
    var header = document.querySelector('header.site');
    if (!header) return;
    var last = null;
    var onScroll = function () {
      var stuck = window.scrollY > 8;
      if (stuck !== last) { header.classList.toggle('is-stuck', stuck); last = stuck; }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  /* ---------------- desktop dropdown menus ---------------- */
  (function () {
    var items = Array.prototype.slice.call(document.querySelectorAll('.has-menu'));
    if (!items.length) return;
    var openTimer, closeTimer;

    function closeAll(except) {
      items.forEach(function (it) {
        if (it === except) return;
        it.classList.remove('open');
        var b = it.querySelector(':scope > .tt');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }

    function open(it) {
      closeAll(it);
      it.classList.add('open');
      var b = it.querySelector(':scope > .tt');
      if (b) b.setAttribute('aria-expanded', 'true');
    }

    function close(it) {
      it.classList.remove('open');
      var b = it.querySelector(':scope > .tt');
      if (b) b.setAttribute('aria-expanded', 'false');
    }

    items.forEach(function (it) {
      var btn = it.querySelector(':scope > .tt');
      if (!btn) return;

      /* pointer: open on hover with a small delay so it does not flicker */
      it.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        clearTimeout(closeTimer);
        openTimer = setTimeout(function () { open(it); }, 70);
      });
      it.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { close(it); }, 180);
      });

      /* click / tap / keyboard toggles */
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        clearTimeout(openTimer); clearTimeout(closeTimer);
        if (it.classList.contains('open')) { close(it); } else { open(it); }
      });

      btn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault(); open(it);
          var first = it.querySelector('.panel a');
          if (first) first.focus();
        }
      });

      /* leaving the panel by keyboard closes it */
      it.addEventListener('focusout', function (e) {
        if (!it.contains(e.relatedTarget)) close(it);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var opened = document.querySelector('.has-menu.open');
        closeAll(null);
        if (opened) { var b = opened.querySelector(':scope > .tt'); if (b) b.focus(); }
      }
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.has-menu')) closeAll(null);
    });

    mq.addEventListener('change', function () { closeAll(null); });
  })();

  /* ---------------- mobile drawer ---------------- */
  (function () {
    var burger = document.querySelector('.burger');
    var drawer = document.getElementById('MobileDrawer');
    var scrim  = document.getElementById('DrawerScrim');
    if (!burger || !drawer) return;
    var lastFocus = null;

    function setOpen(on) {
      drawer.classList.toggle('on', on);
      if (scrim) scrim.classList.toggle('on', on);
      burger.setAttribute('aria-expanded', on ? 'true' : 'false');
      drawer.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.body.classList.toggle('no-scroll', on);
      if (on) {
        lastFocus = document.activeElement;
        var f = drawer.querySelector('a,button');
        if (f) setTimeout(function () { f.focus(); }, 260);
      } else if (lastFocus) {
        lastFocus.focus();
      }
    }

    burger.addEventListener('click', function () {
      setOpen(!drawer.classList.contains('on'));
    });
    if (scrim) scrim.addEventListener('click', function () { setOpen(false); });
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (b) {
      b.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('on')) setOpen(false);
    });
    mq.addEventListener('change', function () { if (isDesktop()) setOpen(false); });

    /* accordion submenus */
    drawer.querySelectorAll('.d-item > button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.parentElement;
        var open = item.classList.contains('open');
        item.classList.toggle('open', !open);
        btn.setAttribute('aria-expanded', !open ? 'true' : 'false');
      });
    });
  })();

  /* ---------------- search bar ---------------- */
  (function () {
    var toggle = document.querySelector('.search-toggle');
    var bar = document.getElementById('SearchBar');
    if (!toggle || !bar) return;
    toggle.addEventListener('click', function () {
      var on = !bar.classList.contains('on');
      bar.classList.toggle('on', on);
      toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) { var i = bar.querySelector('input'); if (i) setTimeout(function () { i.focus(); }, 200); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && bar.classList.contains('on')) {
        bar.classList.remove('on');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  })();

  /* ---------------- quantity steppers ---------------- */
  document.querySelectorAll('.qty').forEach(function (box) {
    var input = box.querySelector('input');
    if (!input) return;
    box.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(b.dataset.step, 10) || 1;
        var min = parseInt(input.min, 10); if (isNaN(min)) min = 1;
        var next = (parseInt(input.value, 10) || min) + step;
        input.value = Math.max(min, next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---------------- product gallery thumbs ---------------- */
  (function () {
    var gal = document.querySelector('.pdp .gallery');
    if (!gal) return;
    var main = gal.querySelector('.main img');
    if (!main) return;
    gal.querySelectorAll('.thumbs button').forEach(function (b) {
      b.addEventListener('click', function () {
        var src = b.dataset.full;
        if (src) { main.src = src; main.removeAttribute('srcset'); }
        gal.querySelectorAll('.thumbs button').forEach(function (o) { o.setAttribute('aria-selected', 'false'); });
        b.setAttribute('aria-selected', 'true');
      });
    });
  })();

  /* ---------------- variant picker ---------------- */
  document.querySelectorAll('.product-form').forEach(function (form) {
    var sel = form.querySelector('[data-variant-select]');
    if (!sel) return;

    /* scope display targets to the detail column so option attributes cannot be matched */
    var scope = form.closest('.detail') || form.closest('.pdp') || document;
    var priceEl   = scope.querySelector('[data-price]');
    var compareEl = scope.querySelector('[data-compare]');
    var skuEl     = scope.querySelector('[data-sku]');
    var idInput   = form.querySelector('input[name="id"]');
    var addBtn    = form.querySelector('[data-add]');

    function sync() {
      var opt = sel.options[sel.selectedIndex];
      if (!opt) return;
      if (idInput) idInput.value = opt.value;
      if (priceEl && opt.dataset.optPrice) priceEl.textContent = opt.dataset.optPrice;
      if (compareEl) {
        if (opt.dataset.optCompare) {
          compareEl.textContent = opt.dataset.optCompare;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (skuEl) skuEl.textContent = opt.dataset.optSku || '';
      var avail = opt.dataset.optAvailable === 'true';
      if (addBtn) {
        addBtn.disabled = !avail;
        addBtn.textContent = avail ? (addBtn.dataset.label || 'Add to bag') : 'Sold out';
      }
      if (window.history && window.history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', opt.value);
          window.history.replaceState({}, '', u.toString());
        } catch (e) {}
      }
    }
    sel.addEventListener('change', sync);
    sync();
  });

  /* ---------------- cart: auto-submit on quantity change ---------------- */
  (function () {
    var form = document.getElementById('CartForm');
    if (!form) return;
    form.querySelectorAll('.qty input').forEach(function (input) {
      input.addEventListener('change', function () {
        var t = form.querySelector('[data-cart-update]');
        if (t) t.hidden = false;
      });
    });
  })();

  /* ---------------- live cart count ---------------- */
  (function () {
    var el = document.querySelector('.cart-link .count');
    if (!el) return;
    document.addEventListener('vs:cart-updated', function (e) {
      var n = (e.detail && e.detail.count) || 0;
      el.textContent = n;
      el.setAttribute('data-empty', n === 0 ? 'true' : 'false');
    });
  })();

})();
